// extracted by mini-css-extract-plugin
export default {"container":"FU-z","error":"GU-z","disabled":"HU-z","submit":"IU-z","option":"JU-z","success":"KU-z","failure":"LU-z"};